import React from "react";
import { PrimaryButton, Stack } from "@fluentui/react";

interface Props {
    onContinue: () => void;
}

export const StepWelcome: React.FC<Props> = ({ onContinue }) => {

    return (
        <div className="step-welcome-container">

            {/* HEADING ON TOP */}
            <h2 className="create-account-heading">Welcome to ZedX</h2>

            <div className="step-welcome-layout">

                {/* TEXT */}
                <div className="step-welcome-text">

                    <p>
                        ZedX is a modern platform designed to help organisations
                        manage governance, risk and compliance in a structured
                        and efficient way.
                    </p>

                    <p>
                        In just a few steps you will create your organisation
                        account, select the applications you require and
                        configure your environment.
                    </p>

                    <p>
                        The process only takes a few minutes and once completed
                        your ZedX environment will be ready to use.
                    </p>

                </div>

                {/* IMAGE */}
                <div className="step-welcome-image">

                    <img
                        src="https://placehold.co/600x400"
                        alt="ZedX Platform"
                    />

                </div>

            </div>

            {/* BUTTON */}
            <Stack horizontal horizontalAlign="start" tokens={{ childrenGap: 12, padding: 0 }} className="step-actions-btns">
                <PrimaryButton text="Continue" onClick={onContinue} />
            </Stack>

        </div>
    );
};